import { Marker, Polygon } from '@react-google-maps/api'
import React, { useCallback, useRef, useState } from 'react'

const GoogleMapZonePolygon = ({ item, index, onChange = () => {} }) => {
  const [hoveredZone, setHoveredZone] = useState(null)
  const [zoomLevel, setZoomLevel] = useState(11)
  let lastClickTime = useRef(0)

  const handleMouseOver = (index) => {
    setHoveredZone(index)
  }

  const handleClickOnChange = useCallback((event) => {
    if (!onChange) return
    if (!window.google) {
      console.log('Google Maps API no está cargado')
      return // protección extra
    }

    const now = Date.now()
    if (now - lastClickTime.current < 1000) return
    lastClickTime.current = now

    onChange(event)
  }, [])

  return (
    <>
      <Polygon
        key={`polygon-${index}`}
        paths={item.coords}
        options={{
          strokeOpacity: 1,
          strokeColor: item.zone.strokeColor,
          fillColor: item.zone.fillColor,
          fillOpacity: 0.15,
          strokeWeight: 0.5,
          clickable: true,
        }}
        onMouseOver={() => handleMouseOver(index)}
        onMouseOut={() => handleMouseOver(null)}
        onClick={handleClickOnChange}
      />
      {/* Mostrar etiquetas de las zonas */}
      <Marker
        key={`marker-${index}`}
        position={item.centroid}
        label={{
          text: item.zone.name,
          className: 'bg-dark p-1 border border-dark rounded',
          fontSize: '10px',
        }}
        visible={zoomLevel <= 11 && hoveredZone === index}
        icon={{
          path: window.google.maps.SymbolPath.CIRCLE,
          scale: 0,
        }}
      />
    </>
  )
}

export default GoogleMapZonePolygon
